import VersionInfo from './components/VersionInfo';
export default VersionInfo;
